import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

const { PROCEDURE_15 } = environment;

@Injectable({
  providedIn: 'root'
})

export class FileService {

  private filesAdded = new BehaviorSubject<any>(null);
  public readonly getFilesAdded$: Observable<any> = this.filesAdded.asObservable();

  constructor(private http: HttpClient) {
  }

  setFilesAdded(_files) {
    this.filesAdded.next(_files);
  }

  saveFile(data: FormData): Observable<any> {
    return this.http.post(`${ PROCEDURE_15 }/Document`, data);
  }
}
